var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-title',{staticClass:"d-flex justify-space-between"},[_c('h3',{staticClass:"headline font-weight-bold"},[_vm._v("Notificaciones")]),_c('v-chip',{attrs:{"small":"","disabled":""}},[_vm._v(_vm._s(_vm.cantidad))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }